import { createReducer } from 'deox';
import { produce } from 'immer';

import { getCompanies } from './actions';
import { CompaniesState } from './types';

const initialState: CompaniesState = {
  loading: false,
  data: {
    count: 0,
    next: null,
    previous: null,
    results: [],
  },
};

export const companiesReducer = createReducer(initialState, (handleAction) => [
  handleAction(getCompanies.request, (state) =>
    produce(state, (draft) => {
      draft.loading = true;
    }),
  ),
  handleAction(getCompanies.success, (state, { payload }) =>
    produce(state, (draft) => {
      draft.loading = false;
      draft.data = {
        ...payload,
        results: [...draft.data.results, ...payload.results],
      };
    }),
  ),
  handleAction(getCompanies.fail, (state) =>
    produce(state, (draft) => {
      draft.loading = false;
    }),
  ),
]);
